import styled from "@emotion/styled";

import { cssVariableValues, fontRobotoCondensed } from "shared/lib/styles";

import { Button } from "scmp-app/components/common/button";

export const ReadFullArticleButton = styled(Button)`
  flex-direction: row;

  inline-size: 100%;
  margin-inline-end: 12px;
  padding: 12px;

  color: #ffffff;
  font-weight: 700;
  font-size: 20px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;

  border-radius: 4px;

  background: #2c4692;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  justify-content: space-between;

  inline-size: 100vw;
  margin-block-start: -100px;
  margin-inline: calc(
    -1 *
      (
        ${cssVariableValues.pageAlignmentPaddingInline} +
          ${cssVariableValues.contentAlignmentPaddingInline}
      )
  );
  padding-block: 60px 32px;
  padding-inline: 10px;

  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, #ffffff 46.5%, #ffffff 100%);
`;

export const Spinner = styled.div`
  inline-size: 20px;
  margin-inline-start: 2px;

  border-radius: 50%;

  background:
    radial-gradient(farthest-side, #4585ff 94%, #00000000) top/3px 3px no-repeat,
    conic-gradient(#00000000 0%, #4585ff);

  animation: l2 1s infinite linear;
  aspect-ratio: 1;
  mask: radial-gradient(farthest-side, #00000000 calc(100% - 3px), #000000 50%);

  @keyframes l2 {
    to {
      transform: rotate(1turn);
    }
  }
`;
